import React, { useState, useEffect, useCallback } from 'react';

const StaticMapRecorrido = ({ recorrido, ultRecorrido }) => {
  const [mapRecorrido, setMapRecorrido] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imageUrl, setImageUrl] = useState(null);
  const [mapKey, setMapKey] = useState(0);
  const [noCoordenadas, setNoCoordenadas] = useState(false);

  // Actualiza el estado del recorrido cuando cambia la prop
  useEffect(() => {
    setLoading(true); // Se activa el loader ANTES de actualizar el recorrido
    setMapRecorrido(recorrido);
    console.log("Recorrido actualizado:", recorrido);
    // console.log("Recorrido actualizado:", recorrido);
  }, [recorrido]);

  // Optimizar la función updateImage con useCallback
  const updateImage = useCallback((path) => {
    if (!path.length) return;
    console.log("Actualizando imagen del mapa con path:", path);

    setLoading(true); // Se asegura de que el loader se active antes de la carga

    try {
      const filteredPath = path.filter(punto => punto.Latitud !== 0 && punto.Longitud !== 0);
      let tolerance = filteredPath.length > 2000 ? 0.4 : filteredPath.length > 1000 ? 0.2 : 0.1;
      const simplifiedPath = simplifyPath(filteredPath, tolerance);
      console.log("Path simplificado:", simplifiedPath);
      const polyline = filteredPath.map(point => `${point.Latitud},${point.Longitud}`).join('|');
      console.log("Polyline para la URL del mapa:", polyline);

      const newImageUrl = `https://maps.googleapis.com/maps/api/staticmap?size=330x330&path=${polyline}&style=feature:all|element:labels|visibility:on&style=feature:all|element:geometry|saturation:0&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;
      console.log("URL de la imagen del mapa generada:", newImageUrl);

      setTimeout(() => {  // Simular carga real y evitar flickering
        setImageUrl(newImageUrl);
        setMapKey(prevKey => prevKey + 1);
        setLoading(false);
      }, 1000); // Tiempo de espera antes de actualizar el mapa
    } catch (err) {
      console.error("Error al actualizar la imagen del mapa:", err);
      setLoading(false);
    }
  }, []);

  // Llama a updateImage solo cuando mapRecorrido cambia
  useEffect(() => {
    if (mapRecorrido.length > 0) {
      updateImage(mapRecorrido);
    }

    if (mapRecorrido.length === 0) {
      setNoCoordenadas(true);
      setLoading(false);
    }
  }, [mapRecorrido, updateImage]);

  // Función para simplificar el path y reducir la cantidad de puntos
  const simplifyPath = (path, tolerance) => {
    const simplifiedPath = [path[0]];

    for (let i = 1; i < path.length - 1; i++) {
      const prevPoint = simplifiedPath[simplifiedPath.length - 1];
      const currentPoint = path[i];
      const distance = calculateDistance(prevPoint, currentPoint);

      if (distance > tolerance) {
        simplifiedPath.push(currentPoint);
      }
    }

    simplifiedPath.push(path[path.length - 1]);
    return simplifiedPath;
  };

  // Función para calcular distancia entre puntos
  const calculateDistance = (point1, point2) => {
    return Math.sqrt(
      Math.pow(point2.latitude - point1.latitude, 2) +
      Math.pow(point2.longitude - point1.longitude, 2)
    );
  };

  return (
    <div
      style={{
        height: "330px",
        width: "100%",
        backgroundColor: "#f3f4f6", // gris claro
      }}
      className="imgUltimoRecorrido"
    >
      {noCoordenadas ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            color: "#6b7280",
          }}
        >
          <FiWifiOff size={55} style={{ marginBottom: "8px" }} />
          <p style={{ margin: 0, fontWeight: 500 }}>
            No hay coordenadas disponibles para mostrar en el mapa.
          </p>
          <small>Problemas de conexión o sin rastreo activo</small>
        </div>
      ) : (
        <>
          {loading ? (
            <div
              style={{
                position: "relative",
                alignContent: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transform: 'translateY(150px)'
              }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only"
                  style={{
                    display: 'flex',
                    alignItems: "center",
                    justifyContent: "center"
                  }}>Loading...</span>
              </div>
            </div>
          ) : (

            <>
              <img
                key={mapKey}
                src={imageUrl}
                onLoad={() => setLoading(false)}
                onError={() => {
                  setLoading(false);
                  console.error("❌ Error cargando la imagen del mapa");
                }}
                style={{
                  display: loading ? "none" : "block",
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
                alt="Mapa del recorrido"
              />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default StaticMapRecorrido;
